import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button } from 'antd';
import intl from 'react-intl-universal';

import SingleViewLayout from './../../layouts/SingleViewLayout/SingleViewLayout';

import './404.css';
import styles from './page404.module.css';
import placeHolderImage from './404.svg';
class Page404 extends Component {
  render() {
    return (
      <SingleViewLayout className={styles.youShallNotPass}>
        <Row className={styles.errorRowForException}>
          <Col span={24} md={11} className={styles.errorColumnForException}>
            <img src={placeHolderImage} alt="forbidden-page" width="100%" style={{ maxHeight: '400px' }} />
          </Col>
          <Col span={0} md={1} lg={0} />
          <Col span={24} md={12} lg={10} className={styles.errorColumnForException}>
            <div className={styles.errorColumnContent}>
              <span className={styles.errorTitle}>{intl.get('403and404.404').d(`404 Oops!`)}</span>
              <span className={styles.errorSubtitle}>
                {intl.get('403and404.content').d(`Page not found. Looks like you're lost. Let me guide you back.`)}
              </span>
              <Button type="primary" size="large" style={{ width: 'auto', margin: '0 auto' }}>
                <Link to="/">{intl.get('403and404.home').d(`Go Home`)}</Link>
              </Button>
            </div>
          </Col>
        </Row>
      </SingleViewLayout>
    );
  }
}

export default Page404;
